module.exports = "/images/chevron-right.svg";